export enum BrowserType {
  SAFARI = 'Safari',
  CHROME = 'Chrome',
  FIREFOX = 'Firefox',
  EDGE = 'Edge',
  OPERA = 'Opera',
  UNKNOWN = 'Unknown',
}
